<template>
  <section class="fluent-anti-carton">
    <div class="fluent-mobile-background"></div>
    <div class="fluent-anti-carton-sticky">
      <div v-textMotion="100" class="anti-carton-text-intro">
        <p class="title">{{ $t('anti-carton-title') }}</p>
        <p class="sub-title">{{ $t('anti-carton-sub-title') }}</p>
        <p class="description">
          {{ $t('anti-carton-description') }}
          <!-- <sup>6</sup> -->
        </p>
      </div>
      <div class="anti-carton-container">
        <div ref="anti1" class="anti-carton-container-box">
          <p>{{ $t('anti-carton-ram') }}</p>
          <p class="anti-carton-number">{{ data1 + '%' }}</p>
        </div>
        <div ref="anti2" class="anti-carton-container-box">
          <p>{{ $t('anti-carton-prsponse') }}</p>
          <p class="anti-carton-number">{{ data2 + '%' }}</p>
        </div>
        <div ref="anti3" class="anti-carton-container-box">
          <p>{{ $t('anti-carton-frane') }}</p>
          <p class="anti-carton-number">{{ data3 + '%' }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ScrollMagic from 'scrollmagic';
import Controller from '../../util/scrollMagic';
export default {
  data() {
    return {
      progress: 0,
      data1: 0,
      data2: 0,
      data3: 0
    };
  },
  computed: {},
  mounted() {
    this.resizeHandler();
    window.addEventListener('resize', this.resizeHandler);
  },
  methods: {
    initScroll() {
      this.scene = new ScrollMagic.Scene({
        duration: 50,
        triggerElement: '.fluent-anti-carton',
        triggerHook: 0,
        offset: 0
      })
        .setPin('.fluent-anti-carton-sticky')
        .addTo(Controller)
        .on('progress', e => {
          this.progress = e.progress;
          if (this.progress > 0 && this.progress < 1 && this.data1 === 0) {
            this.$refs.anti1.classList.add('anti-active');
            this.$refs.anti2.classList.add('anti-active');
            this.$refs.anti3.classList.add('anti-active');
            setTimeout(() => {
              var animation1 = setInterval(() => {
                if (this.data1 > 44) {
                  clearInterval(animation1);
                } else {
                  this.data1++;
                }
              }, 44.44);
              var animation2 = setInterval(() => {
                if (this.data2 > 31) {
                  clearInterval(animation2);
                } else {
                  this.data2++;
                }
              }, 62.5);
              var animation3 = setInterval(() => {
                if (this.data3 > 16) {
                  clearInterval(animation3);
                } else {
                  this.data3++;
                }
              }, 117.65);
            }, 1000);
          } else if (this.progress > 0 && this.progress < 1 && this.data1 === 45) {
            this.scene.destroy(true);
            this.scene = null;
          }
        });
      this.scene.progress(1);
    },
    resizeHandler() {
      if (!this.scene) {
        this.initScroll();
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.fluent-anti-carton {
  position: relative;
  .fluent-anti-carton-sticky {
    position: relative;
    z-index: 1;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    text-align: center;
  }
  .anti-carton-text-intro {
    max-width: 670px;
    .title {
      font-weight: 500;
    }
    .sub-title {
      font-size: 36px;
    }
  }
  .anti-carton-container {
    padding: 12.7vh 0 5.2vh 0;
    display: flex;
    justify-content: center;
    .anti-carton-container-box {
      margin: 0 80px 0 80px;
      text-align: center;
      opacity: 0;
      transition: 1s;
      transform: translate3d(0, 60px, 0);
      .anti-carton-number {
        font-size: 96px;
        line-height: 105%;
        margin-top: 24px;
      }
      p {
        font-size: 18px;
        line-height: 26px;
        font-variation-settings: 'wght' 1000;
      }
    }
    .anti-active {
      margin-top: 0;
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  }
}
@media screen and (max-width: 1100px) {
  .fluent-anti-carton {
    .anti-carton-container {
      width: calc(100% - 40px);
      justify-content: space-between;
      .anti-carton-container-box {
        margin: 0;
      }
    }
  }
}
@media screen and (max-width: 734px) {
  .fluent-anti-carton {
    .fluent-anti-carton-sticky {
      position: relative;
      z-index: 1;
      height: 50vh;
      min-height: 695px;
      width: 100%;
      padding: 0 21px;
      text-align: left;
      align-items: flex-start;
      box-sizing: border-box;
    }
    .anti-carton-text-intro {
      margin-top: 60px;
      .title {
        font-weight: 500;
      }
      .sub-title {
        font-size: 24px;
        line-height: 30px;
      }
      .description {
        padding-top: 20px;
        font-size: 13px;
      }
    }
    .anti-carton-container {
      padding-top: 40px;
      width: 100%;
      display: block;
      .anti-carton-container-box {
        text-align: left;
        p {
          font-size: 16px;
          line-height: 13px;
        }
        .anti-carton-number {
          margin-top: 16px;
          margin-bottom: 40px;
          line-height: 60px;
        }
      }
    }
  }
}
</style>
